import { VStack, Divider, View } from "@gluestack-ui/themed";
import { SecondCopyOfReceiptController } from "./controller";
import { StoreInfoSection } from "@repo/core/components/receipt/sections/StoreInfoSection";
import { TotalSalesSection } from "@repo/core/components/receipt/sections/TotalSalesSection";
import { formatDateTime } from "@repo/core/utils/date.utils";
import Scaffolds from "@repo/core/components/layout/Scaffolds";
import { StatusBarVariantEnum } from "@repo/core/components/layout/StatusBar/types";
import { ShareButton } from "@repo/core/components/core/ShareButton";

const ClosingOfTheDay = () => {
  const {
    back,
    isMobile,
    handleGoToSales,
    dailyInfo,
    viewRef,
    pdfIsLoading,
    handleCaptureAndGeneratePDF
  } = SecondCopyOfReceiptController();
  return (
    <Scaffolds.Root showHeader={false}>
      <Scaffolds.StoreSelect
        title="Fechamento"
        onBackPress={back}
        rightIcon="times"
        rightIconSize={20}
        rightWebLabel="Fechar"
        onPressRightIcon={handleGoToSales}
        statusBarVariant={StatusBarVariantEnum.LIGHT}
        showConfirmStoreModal
      >
        <Scaffolds.Form
          footerContent={
            <View
              w="$full"
              gap="$4"
              flexDirection={!isMobile ? "row-reverse" : "column"}
              pt={isMobile ? "$4" : "$12"}
              px="$4"
              pb="$4"
              justifyContent="flex-end"
            >
              <ShareButton
                flex={isMobile ? undefined : 1}
                onPress={handleCaptureAndGeneratePDF}
                isLoading={pdfIsLoading}
              />
            </View>
          }
        >
          <VStack flex={1} ref={viewRef} collapsable={false}>
            <VStack px="$6">
              <TotalSalesSection
                title="Total de Vendas"
                dateTime={formatDateTime(dailyInfo?.Data, dailyInfo?.Hora)}
                normalSales={parseFloat(dailyInfo.ValorAVista)}
                noInterestSales={parseFloat(dailyInfo.ValorSemJuros)}
                interestSales={parseFloat(dailyInfo.ValorComJuros)}
                cancelledSales={parseFloat(dailyInfo.ValorCancelado)}
                bonusUsed={parseFloat(dailyInfo.ValorUtilizacao)}
                withdraws={parseFloat(dailyInfo.ValorSaque)}
                payments={parseFloat(dailyInfo.ValorPagamento)}
                fidelityPoints={parseFloat(dailyInfo.ValorPontuacao)}
              />
            </VStack>
            <Divider mt="$2" />
            <VStack px="$6">
              <StoreInfoSection
                icon="list"
                title="Dados gerais"
                name={dailyInfo?.NomeLoja || "-"}
                cnpj={dailyInfo?.Cnpj || "-"}
                phone={dailyInfo?.Telefone || "-"}
                address={dailyInfo?.Endereco || "-"}
                nsuTerminal={dailyInfo?.Terminal || "-"}
                nsuProcessor={"-"}
              />
            </VStack>
          </VStack>
        </Scaffolds.Form>
      </Scaffolds.StoreSelect>
    </Scaffolds.Root>
  );
};
export default ClosingOfTheDay;
